
















import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation, namespace } from "vuex-class";
import mentionTabCard from "@/components/layouts/mentionTabCard.vue";
import _ from "lodash";

const CollectionModule = namespace("CollectionModule");

@Component({
  components: {
    mentionTabCard,
  },
})
export default class MentionTab extends Vue {
  @CollectionModule.State("mentionList") mentionList: any;
  @CollectionModule.Action("loadMentions") loadMentions: any;

  mounted() {
    this.load(true);
    this.addScrollEvent(this.scrollView);
  }

  async load(clear: boolean) {
    this.loadMentions(clear);
  }

  get scrollView() {
    return this.$refs.scrollView as any;
  }

  addScrollEvent(scrollView: any) {
    scrollView.addEventListener("scroll", this.throttle);
  }

  destroyed() {
    this.destroyScrollEvent(this.scrollView);
  }

  destroyScrollEvent(scrollView: any) {
    scrollView.removeEventListener("scroll", this.throttle);
  }

  handleScroll() {
    const scrollTop = (this.scrollView && this.scrollView.scrollTop) || this.scrollView.scrollTop;
    const bottomOfWindow = scrollTop + this.scrollView.clientHeight;

    if (this.scrollView.scrollHeight - bottomOfWindow < 150) {
      this.load(false);
    }
  }

  throttle = _.throttle(this.handleScroll, 500);
}
